/**
 *  The purpose of this method is to check if
 *  a language has changed or not
 *
 *  @returns Boolean - true indicates it as changed
 */

export default (language, oldLanguages = []) => {
    const id = language.id;
    if (!id) {
        return true; // No id
    }

    const oldLang = oldLanguages.find(l => l.id === id);
    if (!oldLang) {
        return false; // Does not exist
    }

    const hasChanged =
        language.languageId !== oldLang.languageId ||
        language.proficiencyId !== oldLang.proficiencyId;
    return hasChanged;
};
